module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', [_c('div', {
    staticClass: "rule"
  }, [_c('div', {
    staticClass: "tip"
  }, [_c('div', {
    staticClass: "tip-title"
  }, [_vm._v("活动提醒")]), _vm._v(" "), _c('div', {
    staticClass: "tip-content"
  }, [_c('p', [_vm._v("请关注仁翔药购网的动态哦！")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38563914"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/lucky-drawer/components/Over.vue
// module id = 606
// module chunks = 1